import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";

const RecursoIndisponivel = () => {
  const history = useHistory();
  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 24,
        gap: 12,
      }}
    >
      <div style={{ fontSize: 54 }}>🔒</div>
      <h2 style={{ margin: 0 }}>Recurso não disponível</h2>
      <p style={{ color: "#777", maxWidth: 460, lineHeight: 1.6 }}>
        Esta função não está incluída no plano da sua empresa. Fale com o
        administrador para liberar o acesso.
      </p>
      <Button variant="contained" color="primary" onClick={() => history.push("/tickets")}>
        Voltar aos atendimentos
      </Button>
    </div>
  );
};

export default RecursoIndisponivel;
